import React from 'react'

export default class ThinBar extends React.Component {
  render() {
    const { message } = this.props

    return (
      <span className="thin-bar">
        <span className="wrap">
          <span>{message}</span>
        </span>
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/thin-bar.js